import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import CollapsibleHeader from '../../../../layout/CollapsibleHeader';
import BadgeList from '../../../../common/BadgeList';
import { FOOD_PUBLIC_TYPE } from '../../../../../config/constants';
import ItineraryAdditionalFoods from '../itinerary/ItineraryAdditionalFoods';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { ITINERARY_ADDITIONAL_FOOD_ENDPOINT } from '../../../../../config/endpoints';
import { PUT } from '../../../../../config/permissions';

const ItineraryFoodSection = ({ itineraryId, itineraryFoods }) => {
  const foodResource =
    itineraryFoods && itineraryFoods.length ? (
      <Fragment>
        <h3>Alimentación</h3>

        {itineraryFoods.map((food, index) => (
          <Fragment key={food.id || index}>
            <ResourceProperty label="Proveedor:">
              {food.supplier ? food.supplier.businessName : '-'}
            </ResourceProperty>

            <ResourceProperty label="Público:">
              {food.itineraryFoodDetailList &&
              food.itineraryFoodDetailList.length ? (
                <BadgeList
                  textArray={food.itineraryFoodDetailList.map(
                    ({ publicType }) => ({
                      text:
                        FOOD_PUBLIC_TYPE[publicType] &&
                        FOOD_PUBLIC_TYPE[publicType].label
                          ? FOOD_PUBLIC_TYPE[publicType].label
                          : publicType,
                      color:
                        FOOD_PUBLIC_TYPE[publicType] &&
                        FOOD_PUBLIC_TYPE[publicType].color
                          ? FOOD_PUBLIC_TYPE[publicType].color
                          : undefined,
                    }),
                  )}
                />
              ) : (
                '-'
              )}
            </ResourceProperty>

            {index !== itineraryFoods.length - 1 && <hr />}
          </Fragment>
        ))}
      </Fragment>
    ) : null;

  return (
    <>
      {foodResource}

      <hr />

      <CollapsibleHeader
        headerText="Alimentación Adicional"
        component={ItineraryAdditionalFoods}
        itineraryId={itineraryId}
      />
    </>
  );
};

ItineraryFoodSection.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  itineraryFoods: PropTypes.arrayOf(PropTypes.shape({})),
};

ItineraryFoodSection.defaultProps = {
  itineraryFoods: [],
};

export default withEndpointAuthorization({
  url: ITINERARY_ADDITIONAL_FOOD_ENDPOINT,
  permissionType: PUT,
})(ItineraryFoodSection);
